export default __webpack_public_path__ + "static/media/coursewk-bg-example@2x.a706309b.png";